export default {
  userProfile: {
    header: {
      title: "Paramètres du profil",
      subtitle: "Gérez votre profil Linemate",
    },
    sections: {
      accountDetails: "Détails du compte",
      billing: "Facturation",
    },
    labels: {
      oldPassword: "Ancien mot de passe",
      newPassword: "Nouveau mot de passe",
      confirmNewPassword: "Confirmer le nouveau mot de passe",
      enterYourPassword: "Saisissez votre mot de passe",
      showAll: "Tout afficher",
    },
    descriptions: {
      changePassword: "Changez le mot de passe de votre compte Linemate",
      preferredOdds: "Choisissez vos cotes préférées pour les tendances et Mes picks",
      language: "Sélectionnez la langue dans laquelle vous voulez afficher Linemate.",
      odds: "Sélectionnez le format d'affichage des cotes.",
      theme: "Sélectionnez l'apparence de Linemate.",
      billingPrimary: "Suivez votre plan et vos options de paiement",
      billingSecondary: "Linemate s'associe à Stripe pour simplifier la facturation et la gestion des paiements.",
      deleteAccount: "Supprimer votre compte et ses données",
      deleteAccountSecondary: "Si vous voulez supprimer définitivement votre compte, vous pouvez le faire à droite.",
    },
    actions: {
      update: "Mettre à jour",
      choosePreferredOdds: "Choisir vos cotes préférées",
      saveMyChoices: "Enregistrer mes choix",
      manageBilling: "Gérer la facturation",
      deleteThisAccount: "Supprimer ce compte",
    },
    deleteAccount: {
      confirmMessage: "Voulez-vous vraiment supprimer votre compte? Si oui, continuez ci-dessous.",
      permanentWarning: "Gardez en tête que toutes vos données seront supprimées définitivement de nos serveurs. Cette action mettra fin à votre abonnement pour la prochaine période de facturation et ne peut pas être annulée.",
      acknowledgment: "Je reconnais que toutes les données de ce compte seront supprimées et je veux continuer.",
    },
    validation: {
      passwordRequirements: "Le mot de passe doit contenir une lettre majuscule, une lettre minuscule et au moins 8 caractères.",
      confirmPasswordMismatch: "La confirmation du mot de passe ne correspond pas.",
      incorrectPassword: "Mot de passe incorrect.",
    },
  },
};
